import { useMatches, type UIMatch } from "react-router-dom";

import type { SideBarHandle } from "components/navbar/types";

import {
  RiskMitigationSelect,
  SidebarMiniHeading,
  SidebarSpacer,
} from "./components";
import RiskAssetSelection from "./RiskAssetSelection";
import { OutcomeScenariosSelect } from "components/selects/OutcomeScenarios";

// designs show the sidebar should be collapsible
export const RiskSidebar = () => {
  const matches = useMatches() as Array<UIMatch<unknown, SideBarHandle>>;
  const sidebarMatch = matches.find((match) => match.handle?.sidebar);
  const { items, hasWellSelection } = sidebarMatch?.handle?.sidebar ?? {};

  return (
    <section>
      <SidebarSpacer>
        <SidebarMiniHeading>Risk Filters</SidebarMiniHeading>
      </SidebarSpacer>

      {items?.includes("RiskMitigationSelect") && <RiskMitigationSelect />}
      {items?.includes("OutcomeScenariosSelect") && <OutcomeScenariosSelect />}
      {items?.includes("RiskAssetSelection") && (
        <RiskAssetSelection hasWellSelection={hasWellSelection} />
      )}
    </section>
  );
};

export default RiskSidebar;
